// src/components/documents/SetAllTaxStrip.js — taxlines5-a4c81e37 (tax codes on every line, Stage S5)
//
// The light grey strip above the lines when the company's Settings › Taxes switch is ON: "Set tax for
// all lines" (people who pick tax) and the field-marker count (office roles). Lifted from the estimate
// page (S4) so every editor shows the same strip. Setting all lines is an ordinary unsaved edit; each
// line can then be changed on its own. Renders nothing when there is nothing to show.
import React, { useState } from 'react';
import { setAllChoices, setAllLines, SET_ALL_DONE, fieldMarksText } from '../../utils/documentLineTax';

export default function SetAllTaxStrip({
    lines, onLinesChange, ctx, taxCtx, canPick, fieldMarks, disabled,
    id = 'doced-tax-all', selectClassName = '', selectStyle,
    className = 'flex flex-wrap items-center justify-end gap-x-3 gap-y-2 px-3 py-2 rounded-lg bg-gray-50 border border-gray-100',
}) {
    const [doneFor, setDoneFor] = useState(null);
    if (!(fieldMarks > 0 || canPick)) return null;
    return (
        <div className={className}>
            {fieldMarks > 0 && <span className="mr-auto text-xs font-semibold text-amber-800">{fieldMarksText(fieldMarks)}</span>}
            {doneFor && doneFor === lines && <span className="text-xs font-semibold text-green-700" role="status">{SET_ALL_DONE}</span>}
            {canPick && (
                <div className="flex items-center gap-2">
                    <label htmlFor={id} className="text-[13px] font-semibold text-gray-700">Set tax for all lines</label>
                    <select id={id} value="__choose" disabled={disabled} style={selectStyle} className={selectClassName}
                        onChange={(e) => {
                            const v = e.target.value;
                            if (v === '__choose') return;
                            const next = setAllLines(lines, v, ctx);
                            onLinesChange(next);
                            setDoneFor(next);
                        }}>
                        <option value="__choose">Choose…</option>
                        {setAllChoices(ctx, taxCtx).map((c) => <option key={c.value || 'default'} value={c.value} title={c.title}>{c.label}</option>)}
                    </select>
                </div>
            )}
        </div>
    );
}
